/* eslint-disable object-curly-newline */
/* eslint-disable no-unused-vars */
/* eslint-disable no-use-before-define */
/* eslint-disable no-shadow */
/* eslint-disable camelcase */
/* eslint-disable prefer-destructuring */
/* eslint-disable react/self-closing-comp */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React, {
  useEffect, useMemo, useState,
} from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { getConfig } from '@edx/frontend-platform';
import { sendPageEvent, sendTrackEvent } from '@edx/frontend-platform/analytics';
import { getAuthenticatedHttpClient, getHttpClient } from '@edx/frontend-platform/auth';
import { useIntl } from '@edx/frontend-platform/i18n';
import { Form, Icon, Spinner, StatefulButton } from '@openedx/paragon';
import { ExpandMore } from '@openedx/paragon/icons';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import QueryString from 'query-string';
import { Helmet } from 'react-helmet';
import Skeleton from 'react-loading-skeleton';

import ConfigurableRegistrationForm from './components/ConfigurableRegistrationForm';
import RegistrationFailure from './components/RegistrationFailure';
import {
  backupRegistrationFormBegin,
  clearRegistrationBackendError,
  registerNewUser,
  setEmailSuggestionInStore,
  setUserPipelineDataLoaded,
} from './data/actions';
import {
  FORM_SUBMISSION_ERROR,
  TPA_AUTHENTICATION_FAILURE,
} from './data/constants';
import getBackendValidations from './data/selectors';
import {
  isFormValid, prepareRegistrationPayload,
} from './data/utils';
import messages from './messages';
import { AddressField, DateOfBirthField, EmailField, FirstNameField, HonorCode, LastNameField, ProfessionField, SsncodeField, TermsOfService, UsernameField, ZipcodeField } from './RegistrationFields';
import {
  InstitutionLogistration,
  PasswordField,
  RedirectLogistration,
  ThirdPartyAuthAlert,
} from '../common-components';
import { getThirdPartyAuthContext as getRegistrationDataFromBackend } from '../common-components/data/actions';
import EnterpriseSSO from '../common-components/EnterpriseSSO';
import ThirdPartyAuth from '../common-components/ThirdPartyAuth';
import {
  COMPLETE_STATE, PENDING_STATE, REGISTER_PAGE,
} from '../data/constants';
import {
  getAllPossibleQueryParams, getTpaHint, getTpaProvider, isHostAvailableInQueryParams, setCookie,
} from '../data/utils';

import { FIELDS, PROFESSION_TYPES } from '../register/data/constants';
/**
 * Main Registration Page component
 */
const RegistrationPage = (props) => {
  const { formatMessage } = useIntl();
  const dispatch = useDispatch();

  const registrationEmbedded = isHostAvailableInQueryParams();
  const platformName = getConfig().SITE_NAME;
  const flags = {
    showConfigurableEdxFields: getConfig().SHOW_CONFIGURABLE_EDX_FIELDS,
    showConfigurableRegistrationFields: getConfig().ENABLE_DYNAMIC_REGISTRATION_FIELDS,
    showMarketingEmailOptInCheckbox: getConfig().MARKETING_EMAILS_OPT_IN,
    autoGeneratedUsernameEnabled: getConfig().ENABLE_AUTO_GENERATED_USERNAME,
  };
  const {
    handleInstitutionLogin,
    institutionLogin,
  } = props;

  const backedUpFormData = useSelector(state => state.register.registrationFormData);
  const registrationError = useSelector(state => state.register.registrationError);
  const registrationErrorCode = registrationError?.errorCode;
  const registrationResult = useSelector(state => state.register.registrationResult);
  const shouldBackupState = useSelector(state => state.register.shouldBackupState);
  const userPipelineDataLoaded = useSelector(state => state.register.userPipelineDataLoaded);
  const submitState = useSelector(state => state.register.submitState);

  const fieldDescriptions = useSelector(state => state.commonComponents.fieldDescriptions);
  const optionalFields = useSelector(state => state.commonComponents.optionalFields);
  const thirdPartyAuthApiStatus = useSelector(state => state.commonComponents.thirdPartyAuthApiStatus);
  const autoSubmitRegForm = useSelector(state => state.commonComponents.thirdPartyAuthContext.autoSubmitRegForm);
  const thirdPartyAuthErrorMessage = useSelector(state => state.commonComponents.thirdPartyAuthContext.errorMessage);
  const finishAuthUrl = useSelector(state => state.commonComponents.thirdPartyAuthContext.finishAuthUrl);
  const currentProvider = useSelector(state => state.commonComponents.thirdPartyAuthContext.currentProvider);
  const providers = useSelector(state => state.commonComponents.thirdPartyAuthContext.providers);
  const secondaryProviders = useSelector(state => state.commonComponents.thirdPartyAuthContext.secondaryProviders);
  const pipelineUserDetails = useSelector(state => state.commonComponents.thirdPartyAuthContext.pipelineUserDetails);

  const backendValidations = useSelector(getBackendValidations);
  const queryParams = useMemo(() => getAllPossibleQueryParams(), []);
  const tpaHint = useMemo(() => getTpaHint(), []);

  const [formFields, setFormFields] = useState({ ...backedUpFormData.formFields });
  const [configurableFormFields, setConfigurableFormFields] = useState({ ...backedUpFormData.configurableFormFields });
  const [errors, setErrors] = useState({ ...backedUpFormData.errors });
  const [errorCode, setErrorCode] = useState({ type: '', count: 0 });
  const [formStartTime, setFormStartTime] = useState(null);
  // temporary error state for embedded experience because we don't want to show errors on blur
  const [temporaryErrors, setTemporaryErrors] = useState({ ...backedUpFormData.errors });
  const [isNpiUser, setIsNpiUser] = useState(false);
  const STUDENT_RECORD_NOT_FOUND = 'student-record-not-found';

  const { cta, host } = queryParams;
  const buttonLabel = cta
    ? formatMessage(messages['create.account.cta.button'], { label: cta })
    : formatMessage(messages['create.account.for.free.button']);

  /**
   * Set the userPipelineDetails data in formFields for only first time
   */
  useEffect(() => {
    if (!userPipelineDataLoaded && thirdPartyAuthApiStatus === COMPLETE_STATE) {
      if (pipelineUserDetails && Object.keys(pipelineUserDetails).length > 0) {
        setIsChecked(true); // auto-check the skip NPI checkbox
        setNpi('0000000000');
      }
      if (thirdPartyAuthErrorMessage) {
        setErrorCode(prevState => ({ type: TPA_AUTHENTICATION_FAILURE, count: prevState.count + 1 }));
      }
      if (pipelineUserDetails && Object.keys(pipelineUserDetails).length !== 0) {
        const { name = '', username = '', email = '', firstName = '', lastName = '', city = '', address = '', zipCode = ''} = pipelineUserDetails;
        setFormFields(prevState => ({
          // eslint-disable-next-line max-len
          ...prevState, name, username, email, first_name: firstName, last_name: lastName, address: address, zip_code: zipCode,
        }));
        setConfigurableFormFields((prev) => ({
          ...prev,
          city: city,
        }));
        dispatch(setUserPipelineDataLoaded(true));
      }
    }
  }, [ // eslint-disable-line react-hooks/exhaustive-deps
    thirdPartyAuthApiStatus,
    thirdPartyAuthErrorMessage,
    pipelineUserDetails,
    userPipelineDataLoaded,
  ]);

  useEffect(() => {
    if (!formStartTime) {
      sendPageEvent('login_and_registration', 'register');
      const payload = { ...queryParams, is_register_page: true };
      if (tpaHint) {
        payload.tpa_hint = tpaHint;
      }
      dispatch(getRegistrationDataFromBackend(payload));
      setFormStartTime(Date.now());
    }
  }, [dispatch, formStartTime, queryParams, tpaHint]);

  /**
   * Backup the registration form in redux when register page is toggled.
   */
  useEffect(() => {
    if (shouldBackupState) {
      dispatch(backupRegistrationFormBegin({
        ...backedUpFormData,
        configurableFormFields: { ...configurableFormFields },
        formFields: { ...formFields },
        errors: { ...errors },
      }));
    }
  }, [shouldBackupState, configurableFormFields, formFields, errors, dispatch, backedUpFormData]);

  useEffect(() => {
    if (!backendValidations) {
      return;
    }

    const isStudentError = registrationErrorCode === 'student-record-not-found';

    if (registrationEmbedded) {
      setTemporaryErrors(prevErrors => ({
        ...prevErrors,
        ...(isStudentError
          ? { ...backendValidations, email: '' }
          : backendValidations),
      }));
    } else {
      setErrors(prevErrors => ({
        ...prevErrors,
        ...(isStudentError
          ? { ...backendValidations, email: '' }
          : backendValidations),
      }));
    }
  }, [backendValidations, registrationEmbedded, registrationErrorCode]);


  useEffect(() => {
    if (registrationErrorCode) {
      setErrorCode(prevState => ({
        type: registrationErrorCode,
        count: prevState.count + 1,
      }));
    }
  }, [registrationErrorCode]);

  useEffect(() => {
    if (registrationResult.success) {
      // This event is used by GTM
      sendTrackEvent('edx.bi.user.account.registered.client', {});

      // This is used by the "User Retention Rate Event" on GTM
      setCookie(getConfig().USER_RETENTION_COOKIE_NAME, true);
    }
  }, [registrationResult]);

  const handleOnChange = (event) => {
    const { name } = event.target;
    const value = event.target.type === 'checkbox' ? event.target.checked : event.target.value;
    if (registrationError[name]) {
      dispatch(clearRegistrationBackendError(name));
    }
    setErrors(prevErrors => ({ ...prevErrors, [name]: '' }));
    setFormFields(prevState => ({ ...prevState, [name]: value }));
  };

  const handleErrorChange = (fieldName, error) => {
    if (registrationEmbedded) {
      setTemporaryErrors(prevErrors => ({
        ...prevErrors,
        [fieldName]: error,
      }));
      if (error === '' && errors[fieldName] !== '') {
        setErrors(prevErrors => ({
          ...prevErrors,
          [fieldName]: error,
        }));
      }
    } else {
      setErrors(prevErrors => ({
        ...prevErrors,
        [fieldName]: error,
      }));
    }
  };

  const registerUser = () => {
    // debugger;
    const totalRegistrationTime = (Date.now() - formStartTime) / 1000;
    let payload = { ...formFields, npi };
    if (currentProvider) {
      delete payload.password;
      payload.social_auth_provider = currentProvider;
    }
    if (flags.autoGeneratedUsernameEnabled) {
      delete payload.username;
    }

    payload.name = `${payload.first_name || ''} ${payload.last_name || ''}`.trim();

    // Validating form data before submitting
    const { isValid, fieldErrors, emailSuggestion } = isFormValid(
      payload,
      registrationEmbedded ? temporaryErrors : errors,
      configurableFormFields,
      fieldDescriptions,
      formatMessage,
    );
    setErrors({ ...fieldErrors });
    dispatch(setEmailSuggestionInStore(emailSuggestion));

    // returning if not valid
    if (!isValid) {
      setErrorCode(prevState => ({ type: FORM_SUBMISSION_ERROR, count: prevState.count + 1 }));
      return;
    }

    // Preparing payload for submission
    payload = prepareRegistrationPayload(
      payload,
      configurableFormFields,
      flags.showMarketingEmailOptInCheckbox,
      totalRegistrationTime,
      queryParams);

    // making register call
    dispatch(registerNewUser(payload));
  };

  const handleSubmit = (e) => {
    if (npiStatus === 'Error' && !isChecked) {
      setNpiError("Please resolve your NPI error or check 'I do not have NPI'");
      return;
    }
    e.preventDefault();
    registerUser();
  };

  useEffect(() => {
    if (autoSubmitRegForm && userPipelineDataLoaded) {
      registerUser();
    }
  }, [autoSubmitRegForm, userPipelineDataLoaded]); // eslint-disable-line react-hooks/exhaustive-deps

  const [isChecked, setIsChecked] = useState(false);
  const [npi, setNpi] = useState('');
  const [npiError, setNpiError] = useState('');
  const [npiStatus, setNpiStatus] = useState('');
  const [userDetails, setUserDetails] = useState(null);

  async function handleNpiSubmit(e) {
    e.preventDefault();
    if (!npi.trim()) {
      setNpiError('NPI is required');
      setNpiStatus('Error');
      return;
    }
    setNpiError('');
    setUserDetails(null);
    setNpiStatus('');

    const npiData = { npi: npi.trim() };

    try {
      // Prepare data in URL-encoded format (same as the other function)
      const body = QueryString.stringify(npiData);

      // Request configuration
      const requestConfig = {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          // eslint-disable-next-line no-use-before-define
          'X-CSRFToken': getCookie('csrftoken'),
        },
        isPublic: true, // Assuming this is the same as in `registerRequest`
      };

      // Use your custom authenticated HTTP client to make the request
      const res = await getAuthenticatedHttpClient()
        .post(`${getConfig().LMS_BASE_URL}/npi-validate`, body, requestConfig)
        .catch((e) => {
          throw e;
        });

      const result = res.data;

      if (result.status !== 'OK' || !result.user_details) {
        const errorMsg = result?.npi_error || 'No data found for this NPI.';
        console.error('Error:', errorMsg);
        throw new Error(errorMsg);
      }

      // eslint-disable-next-line object-curly-newline
      const { f_name, l_name, city, state, email = '', country_name = '' } = result.user_details;
      const fullName = `${f_name} ${l_name}`;

      // Update state with user details
      setUserDetails({
        name: fullName,
        first_name: f_name,
        last_name: l_name,
        email,
        city,
        state,
        country_name,
      });

      setFormFields((prev) => ({
        ...prev,
        name: fullName,
        first_name: f_name,
        last_name: l_name,
        email,
        city,
        state,
      }));

      setConfigurableFormFields((prev) => ({
        ...prev,
        city,
        state,
      }));

      setNpiStatus('OK');
      setIsChecked(true);
      setIsNpiUser(true);
    } catch (err) {
      let errorMessage = 'An unknown error occurred while validating the NPI.';

      if (err?.response?.data?.npi_error) {
        errorMessage = err.response.data.npi_error;
      } else if (typeof err.message === 'string') {
        errorMessage = err.message;
      }

      console.error('NPI fetch failed:', errorMessage);
      setNpiError(errorMessage);
      setNpiStatus('Error');
    }
  }

  // Cookie retrieval function remains the same
  function getCookie(name) {
    let cookieValue = null;
    if (document.cookie && document.cookie !== '') {
      const cookies = document.cookie.split(';');
      for (let i = 0; i < cookies.length; i++) {
        const cookie = cookies[i].trim();
        // eslint-disable-next-line prefer-template
        if (cookie.substring(0, name.length + 1) === name + '=') {
          cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
          break;
        }
      }
    }
    return cookieValue;
  }

  const handleSkipNpi = (e) => {
    const checked = e.target.checked;
    setIsChecked(checked);

    if (checked) {
      // User chooses to skip NPI
      setNpi('0000000000');
      setIsNpiUser(false);
      setNpiError('');
      setNpiStatus('');
      setUserDetails(null);
    }
  };

  const renderForm = () => {
    if (institutionLogin) {
      return (
        <InstitutionLogistration
          secondaryProviders={secondaryProviders}
          headingTitle={formatMessage(messages['register.institution.login.page.title'])}
        />
      );
    }
    let showTermsOfServiceAndHonorCode = false;
    const formFieldDescriptions = [];
    const honorCode = [];
    if (flags.showConfigurableRegistrationFields) {
      Object.keys(fieldDescriptions).forEach(fieldName => {
        const fieldData = fieldDescriptions[fieldName];
        // eslint-disable-next-line default-case
        switch (fieldData.name) {
          case FIELDS.HONOR_CODE:
            if (fieldData.type === 'tos_and_honor_code') {
              showTermsOfServiceAndHonorCode = true;
            } else {
              honorCode.push(
                <span key={fieldData.name}>
                  <HonorCode
                    fieldType={fieldData.type}
                    value={formFields[fieldData.name]}
                    onChangeHandler={handleOnChange}
                  />
                </span>,
              );
            }
            break;
          case FIELDS.TERMS_OF_SERVICE:
            honorCode.push(
              <span key={fieldData.name}>
                <TermsOfService
                  value={formFields[fieldData.name]}
                  onChangeHandler={handleOnChange}
                />
              </span>,
            );
            break;
        }
      });
    }
    if (flags.showConfigurableEdxFields || showTermsOfServiceAndHonorCode) {
      formFieldDescriptions.push(
        <span key="honor_code">
          <HonorCode fieldType="tos_and_honor_code" onChangeHandler={handleOnChange} value={formFields.honor_code} />
        </span>,
      );
    }
    return (
      <>
        <Helmet>
          <title>{formatMessage(messages['register.page.title'], { siteName: getConfig().SITE_NAME })}</title>
        </Helmet>
        <RedirectLogistration
          host={host}
          authenticatedUser={registrationResult.authenticatedUser}
          success={registrationResult.success}
          redirectUrl={registrationResult.redirectUrl}
          finishAuthUrl={finishAuthUrl}
          optionalFields={optionalFields}
          registrationEmbedded={registrationEmbedded}
          redirectToProgressiveProfilingPage={
            getConfig().ENABLE_PROGRESSIVE_PROFILING_ON_AUTHN && !!Object.keys(optionalFields.fields).length
          }
        />
        {autoSubmitRegForm && !errorCode.type ? (
          <div className="mw-xs mt-5 text-center">
            <Spinner animation="border" variant="primary" id="tpa-spinner" />
          </div>
        ) : (
          <div
            className={classNames(
              'mw-xs mt-3',
              { 'w-100 m-auto pt-4 main-content': registrationEmbedded },
            )}
          >
            <ThirdPartyAuthAlert
              currentProvider={currentProvider}
              platformName={platformName}
              referrer={REGISTER_PAGE}
            />
            <RegistrationFailure
              errorCode={errorCode.type}
              failureCount={errorCode.count}
              context={{
                provider: currentProvider,
                errorMessage: thirdPartyAuthErrorMessage,
                studentErrorMessage: backendValidations?.email,
              }}
            />
            <Form id="registration-form">
              {!isChecked && (
                <>
                  {!registrationEmbedded && (
                    <ThirdPartyAuth
                      currentProvider={currentProvider}
                      providers={providers}
                      secondaryProviders={secondaryProviders}
                      handleInstitutionLogin={handleInstitutionLogin}
                      thirdPartyAuthApiStatus={thirdPartyAuthApiStatus}
                    />
                  )}
                  {(!pipelineUserDetails || Object.keys(pipelineUserDetails).length === 0) && (
                    <div className="help-divider">
                      <div className="line"></div>
                      <span className="text">Or create new one with:</span>
                      <div className="line" />
                    </div>
                  )}

                  <div className="form-group">
                    <input
                      id="register-npi"
                      type="text"
                      name="npi"
                      className="form-control"
                      maxLength="10"
                      value={npi}
                      onChange={(e) => setNpi(e.target.value)}
                      placeholder="Enter NPI"
                    />
                  </div>
                  {npiError && <div className="text-danger">{npiError}</div>}

                  <button type="button" className="npiEnterButton" onClick={handleNpiSubmit}>
                    Next
                  </button>
                  <br />
                  <label>
                    <input
                      type="checkbox"
                      className="npi-checkbox"
                      checked={isChecked}
                      onChange={handleSkipNpi}
                    />
                    I do not have an NPI
                  </label>
                </>
              )}

              {isChecked && (
                <>
                  {!registrationEmbedded && (
                    <ThirdPartyAuth
                      currentProvider={currentProvider}
                      providers={providers}
                      secondaryProviders={secondaryProviders}
                      handleInstitutionLogin={handleInstitutionLogin}
                      thirdPartyAuthApiStatus={thirdPartyAuthApiStatus}
                    />
                  )}
                  {(!pipelineUserDetails || Object.keys(pipelineUserDetails).length === 0) && (
                    <div className="help-divider">
                      <div className="line" />
                      <span className="text">Or create new one with:</span>
                      <div className="line" />
                    </div>
                  )}
                  {!isNpiUser && (
                    <>
                      <label className="student-label">
                        <input
                          type="checkbox"
                          name="is_student"
                          className="student-checkbox"
                          checked={!!formFields.is_student}
                          onChange={handleOnChange}
                        />
                        Are you a student?
                      </label>

                      {formFields.is_student && (
                        <div className="student-email-notice">
                          To sign up for student access, you must use your school email address.
                        </div>
                      )}
                    </>
                  )}
                  <FirstNameField
                    name="first_name"
                    value={formFields.first_name}
                    shouldFetchUsernameSuggestions={!formFields.username.trim()}
                    handleChange={handleOnChange}
                    handleErrorChange={handleErrorChange}
                    errorMessage={errors.first_name}
                    floatingLabel={formatMessage(messages['registration.firstname.label'])}
                  />
                  <LastNameField
                    name="last_name"
                    value={formFields.last_name}
                    handleChange={handleOnChange}
                    handleErrorChange={handleErrorChange}
                    errorMessage={errors.last_name}
                    floatingLabel={formatMessage(messages['registration.lastname.label'])}
                  />
                  <EmailField
                    name="email"
                    value={formFields.email}
                    confirmEmailValue={configurableFormFields?.confirm_email}
                    handleErrorChange={handleErrorChange}
                    handleChange={handleOnChange}
                    errorMessage={errors.email}
                    helpText={[formatMessage(messages['help.text.email'])]}
                    floatingLabel={formatMessage(messages['registration.email.label'])}
                  />
                  {!flags.autoGeneratedUsernameEnabled && (
                    <UsernameField
                      name="username"
                      spellCheck="false"
                      value={formFields.username}
                      handleChange={handleOnChange}
                      handleErrorChange={handleErrorChange}
                      errorMessage={errors.username}
                      helpText={[formatMessage(messages['help.text.username.1']), formatMessage(messages['help.text.username.2'])]}
                      floatingLabel={formatMessage(messages['registration.username.label'])}
                    />
                  )}
                  {!currentProvider && (
                    <PasswordField
                      name="password"
                      value={formFields.password}
                      handleChange={handleOnChange}
                      handleErrorChange={handleErrorChange}
                      errorMessage={errors.password}
                      floatingLabel={formatMessage(messages['registration.password.label'])}
                    />
                  )}
                  <DateOfBirthField
                    name="date_of_birth"
                    value={formFields.date_of_birth}
                    handleChange={handleOnChange}
                    handleErrorChange={handleErrorChange}
                    errorMessage={errors.date_of_birth}
                    floatingLabel={formatMessage(messages['registration.dob.label'])}
                  />
                  <ProfessionField
                    value={formFields.profession_type}
                    handleChange={(e) => setFormFields({
                      ...formFields,
                      profession_type: e.target.value,
                    })}
                    handleErrorChange={handleErrorChange}
                    trailingElement={<Icon src={ExpandMore} />}
                    errorMessage={errors.profession_type}
                    floatingLabel={formatMessage(messages['registration.address.label'])}
                  />
                  {formFields.profession_type === PROFESSION_TYPES.TEACHER && (
                    <SsncodeField
                      name="last_five_digits_of_social_security_number"
                      value={formFields.last_five_digits_of_social_security_number}
                      handleChange={handleOnChange}
                      handleErrorChange={handleErrorChange}
                      errorMessage={errors.last_five_digits_of_social_security_number}
                      floatingLabel={formatMessage(messages['registration.ssncode.label'])}
                      professionType={formFields.profession_type}
                    />
                  )}
                  <AddressField
                    name="address"
                    value={formFields.address}
                    handleChange={handleOnChange}
                    handleErrorChange={handleErrorChange}
                    errorMessage={errors.address}
                    floatingLabel={formatMessage(messages['registration.address.label'])}
                  />
                  <ConfigurableRegistrationForm
                    email={formFields.email}
                    fieldErrors={errors}
                    formFields={configurableFormFields}
                    setFieldErrors={registrationEmbedded ? setTemporaryErrors : setErrors}
                    setFormFields={setConfigurableFormFields}
                    autoSubmitRegisterForm={autoSubmitRegForm}
                    fieldDescriptions={fieldDescriptions}
                  />
                  <ZipcodeField
                    name="zip_code"
                    value={formFields.zip_code}
                    handleChange={handleOnChange}
                    handleErrorChange={handleErrorChange}
                    errorMessage={errors.zip_code}
                    floatingLabel={formatMessage(messages['registration.zipcode.label'])}
                  />
                  {formFieldDescriptions}
                  <StatefulButton
                    id="register-user"
                    type="submit"
                    variant="brand"
                    className="register-button"
                    state={submitState}
                    labels={{ default: buttonLabel, pending: '' }}
                    onClick={handleSubmit}
                    onMouseDown={(e) => e.preventDefault()}
                  />
                </>
              )}
            </Form>
          </div>
        )}

      </>
    );
  };

  if (tpaHint) {
    if (thirdPartyAuthApiStatus === PENDING_STATE) {
      return <Skeleton height={36} />;
    }
    const { provider, skipHintedLogin } = getTpaProvider(tpaHint, providers, secondaryProviders);
    if (skipHintedLogin) {
      window.location.href = getConfig().LMS_BASE_URL + provider.registerUrl;
      return null;
    }
    return provider ? <EnterpriseSSO provider={provider} /> : renderForm();
  }
  return (
    renderForm()
  );
};

RegistrationPage.propTypes = {
  institutionLogin: PropTypes.bool,
  // Actions
  handleInstitutionLogin: PropTypes.func,
};

RegistrationPage.defaultProps = {
  handleInstitutionLogin: null,
  institutionLogin: false,
};

export default RegistrationPage;
